<template>
  <div class="tab-content" v-if="selectedMainTab !== 'affiliation'">
    <div class="tab-pane active">
      <table class="table main-table-aff">
        <thead>
          <tr class="tr-info">
            <th class="th-assigned-to">ID</th>
            <th class="th-assigned-to">URL</th>
            <th class="th-assigned-to">CAMPAIGN</th>
            <th class="th-assigned-to">IP</th>
            <th class="th-assigned-to">COUNTRY</th>
            <th class="th-assigned-to">VISIT DATE</th>
          </tr>
          <tr />
        </thead>
        <tbody>
          <tr
            v-for="client in clickedClients"
            :key="client.id"
            :class="{
              'selected-client': client.id === highlightedClientId,
              'selected-client-hover': client.id === highlightedHoverClientId
            }"
            @click="highlightedClientId = client.id"
            @mouseenter="highlightedHoverClientId = client.id"
            @mouseleave="highlightedHoverClientId = null"
          >
            <td>{{ client.id }}</td>
            <td>{{ client.url }}</td>
            <td>{{ client.campaign_id }}</td>
            <td>{{ client.ip }}</td>
            <td>
              {{
                dictionaries.general.countries.find(
                  country => country.id === client.country_id
                ).name
              }}
            </td>
            <td>{{ client.created_at }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import UsersPermissionCheck from "../../../mixins/user/auth/UsersPermissionCheck";
import UsersStatsActiveScope from "../../company.feature/sub_features.company/clients_table.sub_feature.company/mixins/UsersStatsActiveScope";
import UsersActiveScope from "../../company.feature/sub_features.company/clients_table.sub_feature.company/mixins/UsersActiveScope";
import apiClientCreator from "../../../helpers/api/request";
import { mapState } from "vuex";

export default {
  name: "AffiliationTable.container",
  props: {
    clickedClients: {
      type: Array,
      required: true
    }
  },
  mixins: [UsersPermissionCheck, UsersStatsActiveScope, UsersActiveScope],
  computed: {
    ...mapState("clients", ["dictionaries"])
  },
  created() {
    this.$emit("set-page");
    // this.fetchClickedClients();
  },
  data() {
    return {
      highlightedHoverClientId: null,
      highlightedClientId: null,
      clientsBusy: false,
      clients: []
    };
  },
  methods: {
    async fetchClickedClients() {
      if (!this.clientsBusy) {
        try {
          this.clientsBusy = true;
          const res = await apiClientCreator(`affiliation/client/click`).get(
            ""
          );
          this.clients = res.data.data;
          this.clientsBusy = false;
        } catch (e) {}
      }
    }
  }
};
</script>

<style lang="scss">
.main-table-aff {
  margin-bottom: 0px;
  background-color: white;
  font-family: "Montserrat" !important;
  font-size: 13px;
}

.selected-client-hover {
  background-color: #eceff1;
}

.main-table > tbody > tr::selection,
.selected-client {
  background-color: #cfd8dc;
}

.main-table td {
  border-color: #cfd8dc;
  padding-bottom: 1px;
}

.tr-hover-override :hover {
  background-color: #eceff1;
}

.tr-info {
  border-top-width: thin;
  border-left-width: thin;
  border-right-width: thin;
}
</style>
